import React from 'react'

function StyledCursor() {
  return (
    <div className="df-custom-cursor-wrap">
      <div id="df-custom-cursor"></div>
    </div>
  )
}

export { StyledCursor }